/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentDefinitionListRequest {
    getFixupPrototypeFunction() { return AssessmentDefinitionListRequest.fixupPrototype; }

    static newInstance(model: Partial<AssessmentDefinitionListRequest>): AssessmentDefinitionListRequest {
        let obj = Object.assign(new AssessmentDefinitionListRequest(), model);
        AssessmentDefinitionListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentDefinitionListRequest>): AssessmentDefinitionListRequest {
        if (!model) return null;
        return AssessmentDefinitionListRequest.newInstance(<AssessmentDefinitionListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentDefinitionListRequest) {
        if (!obj) return;

        models.AssessmentDefinitionListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentDefinitionListRequest): boolean {
        Object.setPrototypeOf(obj, AssessmentDefinitionListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AssessmentFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AssessmentDefinitionListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AssessmentDefinitionListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AssessmentFilter;

}
